<template>
  <div>
    <div class="body">
      <div class="table">
        <el-table :data="tableData" :default-sort="{ prop: 'date', order: 'descending' }"
          :header-cell-style="{ background: '#EDEFF4' }" style="width: 100%">
          <!-- NO -->
          <el-table-column align="center" label="NO" prop="rowNumber" width="80">
          </el-table-column>
          <!-- 客户ID -->
          <el-table-column align="center" :label="$t('message.userID')" prop="user_id">
          </el-table-column>
          <!-- 客户名称 -->
          <el-table-column align="center" :label="$t('message.userName')" prop="realname">
          </el-table-column>
          <!-- 记录生成时间 -->
          <el-table-column align="center" :label="$t('message.recordGenerationTime')" prop="created_at" width="150">
          </el-table-column>
          <!-- 咨询时间 -->
          <el-table-column align="center" :label="$t('message.consultationTime')" prop="consult_at" width="150">
          </el-table-column>
          <!-- 咨询来源 -->
          <el-table-column align="center" :label="$t('message.consultationSource')" prop="source_name">
          </el-table-column>
          <!-- 咨询内容 -->
          <el-table-column align="center" :label="$t('message.customerConsultationContent')" prop="content" width="300">
            <template slot-scope="scope">
              <div v-html="scope.row.content" class="template"></div>
            </template>
          </el-table-column>
          <!-- 回复内容 -->
          <el-table-column align="center" :label="$t('message.replyContent')" prop="reply" width="300">
            <template slot-scope="scope">
              <div v-html="scope.row.reply" class="template"></div>
            </template>
          </el-table-column>
          <!-- 问题类别 -->
          <el-table-column align="center" :label="$t('message.typeOfProblem')" prop="category">
          </el-table-column>
          <!-- 状态 -->
          <el-table-column align="center" :label="$t('message.status')" prop="status_name">
          </el-table-column>
          <!-- 操作 -->
          <el-table-column align="center" :label="$t('message.operation')" width="150">
            <template slot-scope="scope">
              <!-- 修改 -->
              <el-button size="mini" type="success" @click="edit(scope.row)" v-if="scope.row.status != 1">
                {{ $t("message.edit") }}
              </el-button>
              <!-- 删除 -->
              <el-button size="mini" type="success" @click="consultDelete(scope.row.id)" class="dark">
                {{ $t("message.delete") }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <div class="paginationContainer">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="datas.page"
          :page-sizes="[10, 20, 50, 100]" :page-size="datas.pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <!-- 咨询登记 -->
    <consultationRegistration :isAdd="false" :formData="formData" ref="consultationRegistration" />
  </div>
</template>
<script>
import consultationRegistration from './consultationRegistration'
export default {
  components: {
    consultationRegistration,
  },
  props: {
    user_id: { type: Number }
  },
  data() {
    return {
      tableData: [],
      datas: {
        page: 1,
        pageSize: 10
      },
      total: 0,
      formData: {},
    };
  },
  created() {

  },
  methods: {
    consultList() {
      this.datas.user_id = this.user_id
      this.$api.JapaneseOffice.consultList(this.datas).then((res) => {
        this.tableData = res.data.data;
        this.total = res.data.total;
      });
    },
    search() {
      this.datas.page = 1
      this.consultList();
    },
    // 显示修改
    edit(item) {
      this.formData = JSON.parse(JSON.stringify(item));
      this.$refs.consultationRegistration.dialogVisible = true;
    },
    // 删除
    consultDelete(id) {
      this.$confirm(
        this.$t("message.areYouSureToDelete"),
        this.$t("message.prompt"),
        {
          confirmButtonText: this.$t("message.ok"),
          cancelButtonText: this.$t("message.cancel"),
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.$api.JapaneseOffice.consultDelete({ id }).then((res) => {
            this.$message.success(res.msg);

            this.consultList();
          });
        })
        .catch(() => { });
    },
    // 分页
    handleCurrentChange(val) {
      this.datas.page = val;
      this.consultList();
    },
    handleSizeChange(val) {
      this.datas.pageSize = val;
      this.consultList();
    },

  },
};
</script>
<style lang='scss' scoped>
.search {
  display: flex;
  margin-bottom: 24px;

  .item {
    margin-right: 24px;
  }
}

.template {
  width: 100%;
  text-align: left
}
</style>